import React from 'react';
import { ArrowDownIcon } from 'lucide-react';
import { costRows } from '../data/comparaciones';
import { Emoji } from './Emoji';
export function CostoDeNoTenerlo() {
  return <section className="w-full bg-forest-800 py-20" data-id="element-48" data-mp="2f7z3npcar9mj">
      <div className="mx-auto max-w-[680px] px-5 text-center sm:px-8" data-id="element-49" data-mp="2f7gzm6je7r42">
        <h2 className="inline-flex flex-wrap items-center justify-center gap-2 font-display text-3xl font-extrabold leading-[1.08] tracking-tight text-cream sm:text-4xl" data-id="element-50" data-mp="2k6afu6q2dw7x">
          <Emoji symbol="⚖️" className="text-3xl" data-id="element-51" data-mp="2a8vz0608b5f3" />
          ¿Cuánto cuesta NO tenerlo?
        </h2>

        <ul className="mt-10 flex flex-col gap-3 text-left" data-id="element-52" data-mp="1whhc3o37ak2r">
          {costRows.map(row => <li key={row.situation} className="rounded-2xl border border-line bg-pistacho px-5 py-5" data-id="element-53" data-mp="20j2prbnk72e0">
              <p className="text-[15px] font-medium text-forest-800" data-id="element-54" data-mp="1mkmfxbuegvrn">
                {row.situation}
              </p>
              <p className="mt-3 flex items-start gap-2 text-[15px] font-bold text-clay" data-id="element-55" data-mp="1rhmmroz2q2jt">
                <ArrowDownIcon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden="true" data-id="element-56" data-mp="1bfp40x2mvs64" />
                {row.cost}
              </p>
            </li>)}
        </ul>

        <p className="mt-12 font-display text-2xl font-extrabold tracking-tight text-cream sm:text-3xl" data-id="element-57" data-mp="1kfklfjms8jel">
          El Mega Pack Cocina Lista cuesta menos que dos semanas de delivery.
        </p>
        <p className="mt-3 font-display text-xl font-bold text-lime-400" data-id="element-58" data-mp="rr6hkn90isv4">
          Y dura para siempre.
        </p>
      </div>
    </section>;
}